import React, { useState, useEffect } from "react";
import user from "../../assets/user2.png"
import ig from "../../assets/Group.png"
import '../App.css';

function InstaFourth({layout,testimonial,media,hashtag,name,profile,colorTheme,time}) {
  const [displayText, setDisplayText] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [fade,setFade]=useState(false);

  useEffect(()=>{
    setTimeout(() => {
      setFade(true)
    }, time-1000);
  })

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < testimonial.length) {
        const currentChar = testimonial.charAt(i);
        setDisplayText(prevText => prevText + currentChar);
        i++;
      } else {
        clearInterval(interval);
      }
    }, 20);
  
    return () => clearInterval(interval);
  }, [testimonial]);

  function getProxiedImageUrl(src) {
    try {
      const proxiedImageUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(src)}`;
      return proxiedImageUrl;
    }
    catch (error) { 
      console.error('Error occurred while generating proxied URL:', error);
      return null; 
    }
  }

  const handleImageError = () => {
    setIsValid(false);
  };

  return (
    layout === "Landscape"?(
       <div>
        {/* <img onError={handleImageError}
       src={profile&&isValid?getProxiedImageUrl(profile):user}
       width={100}
       className={`profile-img ${fade ? 'fade-out' : ''}`}
        style={{
          position: "absolute",
          zIndex: "9",
          top: "10vh",
          left: "31vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out"
        }}
     /> */}
     <div   style={{
          position: "absolute",
          zIndex: "9",
          top: "16vh",
          left: "36vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out",
          background:"white",
          padding:"20px"
        }}
        className={`profile-img ${fade ? 'fade-out' : ''}`}
        >
     <img 
       src={ig}
       width={35}
       className={`profile-img ${fade ? 'fade-out' : ''}`}
      
     />
     </div>
      <div
        className={`content-box-insta ${fade ? 'close-book' : ''}`}
        style={{
            position: "absolute",
            left: "38vw",
            top: "22vh",
            background: "white",
            borderRadius: "30px",
            width: "21vw",
            maxHeight:"75vh",
            padding: "5px 17px 17px 17px",
          }}
      >
         <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"100",fontSize:"2.2vw",margin:"0",fontStyle:"italic",minHeight:"3vh"}} className="animated-title">{name?"@"+name:""}</p>
         <div style={{ position: 'relative', display: 'inline-block' }}>
  <img
    src={media}
    className="profile-img"
    style={{
      width: '20vw',
      height: 'auto',
      transition: 'transform 1s ease-in-out'
    }}
  />
  {/* <img
    src={ig}
    style={{
      position: 'absolute',
      top: '1vh',
      right: '0.5vw',
      width: '25px', 
      height: 'auto', 
      zIndex: 1 
    }}
  /> */}
</div>
        <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"400",fontSize:"2vw",margin:"0 0 0vh 0"}} className="animated-title">{hashtag&&"#"+hashtag}</p>
        <p style={{ color: "black", fontWeight: "400", margin: "0vh 0 0 0",fontSize:"1.4vw"  }} className="animated-first">{testimonial}</p>
      </div>
      </div>
    ):(
      <div>
        {/* <img onError={handleImageError}
       src={profile&&isValid?getProxiedImageUrl(profile):user}
       width={100}
       className={`profile-img ${fade ? 'fade-out' : ''}`}
        style={{
          position: "absolute",
          zIndex: "9",
          top: "10vh",
          left: "31vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out"
        }}
     /> */}
     <div   style={{
          position: "absolute",
          zIndex: "9",
          top: "15vh",
          left: "17vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out",
          background:"white",
          padding:"20px"
        }}
        className={`profile-img ${fade ? 'fade-out' : ''}`}
        >
     <img 
       src={ig}
       width={40}
       className={`profile-img ${fade ? 'fade-out' : ''}`}
      
     />
     </div>
      <div
        className={`content-box-insta ${fade ? 'close-book' : ''}`}
        style={{
            position: "absolute",
            left: "20vw",
            top: "18vh",
            background: "white",
            borderRadius: "30px",
            width: "55vw",
            maxHeight:"75vh",
            padding: "5px 17px 17px 17px",
          }}
      >
         <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"100",fontSize:"5vw",margin:"0",fontStyle:"italic",minHeight:"3vh"}} className="animated-title">{name?"@"+name:""}</p>
         <div style={{ position: 'relative', display: 'inline-block' }}>
  <img
    src={media}
    className="profile-img"
    style={{
      width: '50vw',
      height: 'auto',
      transition: 'transform 1s ease-in-out'
    }}
  />
  {/* <img
    src={ig}
    style={{
      position: 'absolute',
      top: '1vh',
      right: '0.5vw',
      width: '25px', 
      height: 'auto', 
      zIndex: 1 
    }}
  /> */}
</div>
        <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"400",fontSize:"4vw",margin:"0 0 0vh 0"}} className="animated-title">{hashtag&&"#"+hashtag}</p>
        <p style={{ color: "black", fontWeight: "400", margin: "0vh 0 0 0",fontSize:"3vw"  }} className="animated-first">{testimonial}</p>
      </div>
      </div>
    )
  )
}

export default InstaFourth;
